import { createNode, PlainDateDataType, PlainTimeDataType, PlainDateTimeDataType } from '@glueapp/graph-types';
import { toPlainDate, toPlainTime, fromPlainDateTime } from '../../utils/temporal';

export const DateToDateTime = createNode({
    id: 'Date to DateTime',
    name: 'Date to DateTime',
    description: 'Combines a Date and an optional Time into a DateTime (defaults to midnight)',
    aiDescription:
        'Takes a Date on the "Date" port and an optional Time on the "Time" port, and outputs a DateTime on the "DateTime" port. Defaults to midnight if no Time is provided.',
    category: 'Date & Time',
    color: '#3b82f6',
    integration: undefined,
    inPorts: {
        Date: PlainDateDataType,
        Time: PlainTimeDataType,
    },
    optionalInPorts: ['Time'],
    outPorts: {
        DateTime: PlainDateTimeDataType,
    },
    execute: function (input) {
        const date = toPlainDate(input.inPorts.Date);
        const time = input.inPorts.Time ? toPlainTime(input.inPorts.Time) : undefined;
        const dateTime = time ? date.toPlainDateTime(time) : date.toPlainDateTime({ hour: 0, minute: 0 });
        return { output: { DateTime: fromPlainDateTime(dateTime) } };
    },
});
